import { h, Component } from 'preact';

import { faceBoxToObjectPosition } from '../../lib/faceBox';
import PresenceDot from './presenceDot';

const AVATAR_COLORS = [
    '#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5',
    '#2196F3', '#00BCD4', '#009688', '#4CAF50', '#FF9800',
    '#FF5722', '#795548', '#607D8B',
];

function getAvatarColor(name) {
    const str = name || '';
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getInitials(name) {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

class Avatar extends Component {
    // Only an explicit boolean gets the presence wrapper — every existing
    // call site (no `online` prop) must keep byte-identical markup.
    withPresence(avatar) {
        const { size = 32, online } = this.props;
        if (online !== true && online !== false) {
            return avatar;
        }
        const dotSize = Math.min(16, Math.max(8, Math.round(size / 4)));
        return (
            <span class='position-relative d-inline-block flex-shrink-0'>
                {avatar}
                <PresenceDot online={online} size={dotSize} />
            </span>
        );
    }

    render() {
        const {
            name, image, size = 32, faceBox,
        } = this.props;
        const dimension = `${size}px`;

        if (image) {
            // No box (or a malformed one) must leave the style string byte-identical
            // to what every existing call site rendered before faceBox existed.
            const objectPosition = faceBoxToObjectPosition(faceBox);
            const style = `width: ${dimension}; height: ${dimension}; object-fit: cover;`
                + (objectPosition ? ` object-position: ${objectPosition};` : '');
            return this.withPresence(
                <img
                    src={image}
                    class='rounded-circle flex-shrink-0'
                    style={style}
                    alt={name || ''}
                />,
            );
        }

        const bg = getAvatarColor(name);
        const initials = getInitials(name);
        return this.withPresence(
            <div
                class='rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center text-white fw-bold'
                style={`width: ${dimension}; height: ${dimension}; background-color: ${bg}; font-size: ${Math.round(size * 0.4)}px;`}
            >
                {initials}
            </div>,
        );
    }
}

export default Avatar;
